import Axios from "axios";
import qs from "qs";
// TODO
// import logger from "../../logging/sumo-logger";
export default class ProductCatalogServiceClient {
    constructor(config) {
        this.productCatalogConfig = config;
    }
    async getAllProducts(bearerToken) {
        const requestUrl = this.buildAllProductsRequestUrl();
        try {
            let res;
            if (bearerToken) {
                res = await Axios.get(requestUrl, {
                    headers: { Authorization: `Bearer ${bearerToken}` },
                });
            }
            else {
                res = await Axios.get(requestUrl);
            }
            return res.data;
        }
        catch (ex) {
            console.log(ex);
        }
    }
    async getProduct(productKey, bearerToken) {
        const requestUrl = this.buildGetProductRequestUrl(productKey);
        try {
            let res;
            if (bearerToken) {
                res = await Axios.get(requestUrl, {
                    headers: { Authorization: `Bearer ${bearerToken}` },
                });
            }
            else {
                res = await Axios.get(requestUrl);
            }
            return res.data;
        }
        catch (ex) {
            console.log(ex);
        }
    }
    async validateCompatibility(request, bearerToken) {
        const requestUrl = this.buildCompatibilityRequestUrlWithVersion(request);
        try {
            let res;
            if (bearerToken) {
                res = await Axios.get(requestUrl, {
                    headers: { Authorization: `Bearer ${bearerToken}` },
                });
            }
            else {
                res = await Axios.get(requestUrl);
            }
            /**
             * Compatibilities are of the following format. Transform it into a dictionary for easy lookup.
             *  [
             *    {
             *      "name": "Corners",
             *      "values": [
             *        "Rounded",
             *        "Standard"
             *      ]
             *    },
             *    {
             *      "name": "Product Orientation",
             *      "values": [
             *        "Horizontal",
             *        "Vertical"
             *      ]
             *    }
             *  ]
             */
            const compatibilities = res.data.list;
            return compatibilities.reduce((result, compatibility) => {
                result[compatibility.name] = compatibility.values;
                return result;
            }, {});
        }
        catch (ex) {
            console.log(ex);
        }
        return Promise.resolve(undefined);
    }
    async getAllCompatibility(request, bearerToken) {
        const requestUrl = this.buildCompatibilityRequestUrlWithVersion(request);
        try {
            let res;
            if (bearerToken) {
                res = await Axios.get(requestUrl, {
                    headers: { Authorization: `Bearer ${bearerToken}` },
                });
            }
            else {
                res = await Axios.get(requestUrl);
            }
            const listCompatibilities = res.data.list;
            const listResult = listCompatibilities.reduce((result, compatibility) => {
                result[compatibility.name] = compatibility.values;
                return result;
            }, {});
            const rangeCompatibilities = res.data.range;
            const rangeResult = rangeCompatibilities.reduce((result, compatibility) => {
                result[compatibility.name] = compatibility.ranges;
                return result;
            }, {});
            return {
                compatibleOptions: listResult,
                compatibleRanges: rangeResult,
            };
        }
        catch (ex) {
            console.log(ex);
        }
        return Promise.resolve(undefined);
    }
    async getCurrentVersion(productKey) {
        var _a;
        const url = `${this.productCatalogConfig.baseUrl}v2/products/${productKey}/versions/current?requestor=${this.productCatalogConfig.requestor}`;
        try {
            const result = await Axios.get(url);
            return (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.version;
        }
        catch (ex) {
            console.error(ex);
        }
        return undefined;
    }
    async getMerchandisableQuantities(productId, selectedOptions, bearerToken) {
        const BASE_URL = `${this.productCatalogConfig.baseUrl}`;
        try {
            const selectedOptionsQueryString = Object.entries(selectedOptions).reduce((result, [property, option]) => {
                result += `&selectedOptions[${encodeURIComponent(property)}]=${encodeURIComponent(option)}`;
                return result;
            }, "");
            const url = `${BASE_URL}products/${productId}/quantities/merchandising?requestor=${this.productCatalogConfig.requestor}${selectedOptionsQueryString}`;
            let response;
            if (bearerToken) {
                response = await Axios.get(url, {
                    headers: { Authorization: `Bearer ${bearerToken}` },
                });
            }
            else {
                response = await Axios.get(url);
            }
            // TODO: We currently only support 'list'. There is also 'range'. Lone Rangers don't currently have tooling on their end
            // to do ranged quantities and have promised to work with us before they start returning ranges.
            return response.data.list;
        }
        catch (ex) {
            // logger.error("Failed to get merchandising quantities", ex);
            return [];
        }
    }
    buildCompatibilityRequestUrl(request) {
        let url = `${this.productCatalogConfig.baseUrl}`;
        let providedValuesQuery = "";
        Object.keys(request.providedValues).map(propertyName => {
            providedValuesQuery += `&${encodeURIComponent(propertyName)}=${encodeURIComponent(request.providedValues[propertyName])}`;
        });
        // eslint-disable-next-line no-case-declarations
        const pathAndQuery = `v2/products/${request.productKey}/getCompatibleOptions?requestor=${this.productCatalogConfig.requestor}${providedValuesQuery}`;
        url += `${pathAndQuery}`;
        return url;
    }
    buildCompatibilityRequestUrlWithVersion(request) {
        if (!request.productVersion) {
            return this.buildCompatibilityRequestUrl(request);
        }
        const query = {
            requestor: this.productCatalogConfig.requestor,
            selectedOptions: request.providedValues,
        };
        const url = `${this.productCatalogConfig.baseUrl}v2/products/${request.productKey}/${request.productVersion}/getCompatibleOptions?${qs.stringify(query)}`;
        return url;
    }
    buildAllProductsRequestUrl() {
        return `${this.productCatalogConfig.baseUrl}products?requestor=${this.productCatalogConfig.requestor}`;
    }
    buildGetProductRequestUrl(productKey) {
        return `${this.productCatalogConfig.baseUrl}products/${productKey}?requestor=${this.productCatalogConfig.requestor}`;
    }
}
//# sourceMappingURL=ProductCatalogService.js.map